import { Component, Input } from '@angular/core';
import { ButtonComponent } from '@shared/button/button.component';
import { UIHelpers } from '@shared/uihelpers';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-viewer-back-button',
  imports: [
    ButtonComponent
  ],
  templateUrl: './viewer-back-button.component.html',
  styleUrl: './viewer-back-button.component.scss'
})
export class ViewerBackButtonComponent {

  @Input() id = 'backToPortalDesktop';
  @Input() label = 'exit';
  @Input() borderRadius = '0 16px 0 0';
  @Input() isInsideIframe: boolean;
  @Input() isActivityComplete: boolean;

  protected readonly zbpIconNames = zbpIconNames;

  close(): void {
    // Non-students will launch viewer assets in a new window.
    setTimeout(() => {
      UIHelpers.goBackToPortal({
        shouldClose: !this.isInsideIframe,
        isActivityComplete: this.isActivityComplete
      });
    }, 500);
  }
}
